import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProjectDetail from "../pages/project/page";
import ProjectPreview from "../pages/project-preview/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/project/:id",
    element: <ProjectDetail />,
  },
  {
    path: "/project-preview/:id",
    element: <ProjectPreview />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
